import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { usePost, useUpdatePost } from '@tribeplatform/react-sdk/hooks';
import { getMappingFields } from '../common/utils/post';
import { useCanQuitEditor } from '../Composer/utils/state';
import { PostContent } from '../Post/PostContent';
import { ReplyEditor } from './ReplyEditor';
export const ReplyContent = ({ reply, edit, onEdit, onCancel, context, }) => {
    const { mutate: updatePost, isLoading } = useUpdatePost();
    const { data: fullReply, isFetching: fetchingFullPost } = usePost({
        variables: { id: reply === null || reply === void 0 ? void 0 : reply.id },
        useQueryOptions: {
            enabled: edit,
        },
    });
    const canQuitEditor = useCanQuitEditor();
    const handleCancel = useCallback(isTouched => {
        if (canQuitEditor({
            isTouched,
        })) {
            onCancel(isTouched);
        }
    }, [onCancel, canQuitEditor]);
    const loading = isLoading || fetchingFullPost;
    const update = useCallback(async (content, editor) => {
        const _content = content || '';
        const postType = (reply === null || reply === void 0 ? void 0 : reply.postType) || (fullReply === null || fullReply === void 0 ? void 0 : fullReply.postType);
        const mappingFields = getMappingFields({
            content: _content,
            postTypeName: postType.name,
        });
        updatePost({
            id: reply.id,
            input: {
                mappingFields,
                publish: true,
            },
        }, {
            onSuccess: () => {
                editor.commands.clearContent();
                onEdit === null || onEdit === void 0 ? void 0 : onEdit();
            },
        });
    }, [reply === null || reply === void 0 ? void 0 : reply.postType, reply.id, fullReply === null || fullReply === void 0 ? void 0 : fullReply.postType, updatePost, onEdit]);
    if (edit) {
        return (_jsx(ReplyEditor, { reply: reply, onCancel: handleCancel, isLoading: loading, onReply: update }, void 0));
    }
    return _jsx(PostContent, { post: reply, context: context }, void 0);
};
//# sourceMappingURL=ReplyContent.js.map